export default __webpack_public_path__ + "static/media/lessons-white.6617ab3b.svg";